import './reset.css'
import './grid.css'
import 'remixicon/fonts/remixicon.css'

import { createGlobalStyle } from 'styled-components'

/**
 * @function GlobalStyle
 */
export const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: ${p => p.theme.fonts.primary};
    height: 100%;
    scroll-behavior: smooth;
    background: #ffffff;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  @media only screen and (min-width: 40rem) {
    ::-webkit-scrollbar {
      width: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: ${p => p.theme.colors.dark};
   }
  }
`
